import { render, staticRenderFns } from "./MainFooter.vue?vue&type=template&id=8f02698e&scoped=true"
import script from "./MainFooter.js?vue&type=script&lang=js&external"
export * from "./MainFooter.js?vue&type=script&lang=js&external"
import style0 from "./MainFooter.vue?vue&type=style&index=0&id=8f02698e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f02698e",
  null
  
)

export default component.exports